// Custom jQuery Validate rules, registered on import (extracted from the
// former sepaone_app.js document-ready wrapper so they are testable).
import jQuery from "jquery";
import "jquery-validation";
import { AmountFormatter } from "./amount_formatter";

// Override default number validator to accept commas as decimal separators (German format)
// This allows "160,21" in addition to "160.21"
jQuery.validator.methods.number = function(value, element) {
  return this.optional(element) || /^-?(?:\d+|\d{1,3}(?:[\s\.,]\d{3})+)(?:[,\.]\d+)?$/.test(value);
};

jQuery.validator.addMethod("maxAmount", function(value, element, params) {
  const in_cents = jQuery(element).attr('name').replace(/(.+)\[(.+)\]/, '$1[$2_in_cents]')
  return jQuery('[name="'+in_cents +"\"]").val() <= AmountFormatter.centifyAmount(params)
}, jQuery.validator.format("Please enter no more than {0} EUR"));

jQuery.validator.addMethod("minAmount", function(value, element, params) {
  const in_cents = jQuery(element).attr('name').replace(/(.+)\[(.+)\]/, '$1[$2_in_cents]')
  return jQuery('[name="'+in_cents +"\"]").val() >= AmountFormatter.centifyAmount(params)
}, jQuery.validator.format("Please enter at least {0} EUR"));
